<template>
<div class="download-page ">
  <client-card
    :mt4-card-info="mt4CardInfo"
  ></client-card>
<!--  <client-card
    :mt4-card-info="traderViewCardInfo"
  ></client-card>-->
</div>
</template>

<script>
import mt4Bg from '../../../assets/images/customer/mt4Bg.png'
import mt5Bg from '../../../assets/images/customer/mt5Bg.png'
import tradeViewBg from '../../../assets/images/customer/tradeViewBg.png'
import clientCard from "@/components/download/clientCard";
export default {
  name: "index",
  components:{
    clientCard
  },
  data() {
    let _this = this;
    return {
      mt4CardInfo: {
        imgBg: mt4Bg,
        title: 'MT4',
        subtitle: _this.$t('Download_MetaTrader_4_and_experience_the_best_trading'),
        clienlists: [
          {
            symbol: 'iconWindows',
            smallText: _this.$t('Windows_desktop_version'),
            desc: _this.$t('System_requirements_Applicable_to_Windows_2008_7_8_10_operating_system'),
            link: 'https://download.metatrader.com/cdn/web/maxain.group.limited/mt4/maxaingroup4setup.exe',
          },
          {
            symbol: 'iconiOS',
            smallText: _this.$t('Mac_desktop_version'),
            desc: _this.$t('System_requirements_Applicable_to_Mac_OS'),
            link: 'https://download.mql5.com/cdn/web/metaquotes.software.corp/mt4/MetaTrader4.dmg',
          },
          {
            symbol: 'iconAndroid',
            smallText: 'Android APK',
            desc: _this.$t('Download_instructions_After_downloading_you_can_install_the_APK_through_your_mobile_phone'),
            link: 'https://maxain-prod.s3-accelerate.amazonaws.com/files/MetaTrader4.apk'
          },
          {
            symbol: 'iconiOS',
            smallText: _this.$t('iOS_mobile_version'),
            desc: _this.$t('Download_instructions_iPhone_and_iPad_users_can_search_for_MetaTrader4_and_install_it_through_the_Apple_App_Store'),
            link: 'https://download.mql5.com/cdn/mobile/mt4/ios?server=MaxainGroup-Demo,MaxainGroup-Live'
          },
        ]
      },
      traderViewCardInfo: {
        imgBg: tradeViewBg,
        title: 'RS APP',
        subtitle: _this.$t('Use_RS_APP_to_manage_your_account_and_make_quick_transactions'),
        clienlists:  [
          {
            symbol: 'iconAndroid',
            smallText: 'Android APK',
            desc: _this.$t('Download_instructions_After_downloading_you_can_install_the_APK_through_your_mobile_phone'),
            link: '',
          },
        ]
      }
    }
  },
}
</script>

<style scoped>

</style>
